<template>
  <div>
     <el-drawer
      title="新增入库计划"
      direction="ltr"
      :visible.sync="addPlanVisible"
      :before-close="addPlanClose"
      size="45%"
    >
    <div class="topForm" style="margin-left:20px;">
    <el-form
      :model="FormData"
      ref="FormData"
      class="demo-dynamic"
      :rules="Rules"
      :inline="true"
      style="margin-top:20px;" size="small"
    >
      <el-form-item prop="primaryCustomerTaxId"  label="一级货主:">
        <el-select v-model="FormData.primaryCustomerTaxId" :disabled='true' size="mini" placeholder="请选择货主" filterable clearable style="width: 150px">
          <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName" :value="item.taxpayerNumber"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="customerTaxId"  label="二级货主:">
        <el-select v-model="FormData.customerTaxId" size="mini" :disabled='true' placeholder="请选择货主" filterable clearable style="width: 150px">
          <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName" :value="item.taxpayerNumber"></el-option>
        </el-select>
      </el-form-item>
       <el-form-item prop="arrivalMethod" label="到货方式:">
        <el-select v-model="FormData.arrivalMethod" :disabled='true' clearable placeholder="请选择" filterable size="mini" style="width: 150px">
          <el-option
            v-for="(item, index) in arrivalMethodData"
            :key="index"
            :label="item.label"
            :value="item.label"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="plateNumber" label="车船号:">
        <el-input v-model="FormData.plateNumber" :disabled='true' placeholder="请输入车船号" size="mini" style="width: 150px"></el-input>
      </el-form-item>
      <el-form-item prop="vehicleNo" label="车号:">
        <!-- <el-input v-model="FormData.vehicleNo" placeholder="请输入车号" size="mini" style="width: 150px"></el-input> -->
        <el-autocomplete class="inline-input" v-model.trim="FormData.vehicleNo" size="mini" style="width: 150px"
          :fetch-suggestions="querySearch" value-key="vhcNo" @select="handleSelect" popper-class="xiala">
            <template slot-scope="{ item }">
              <div class="name">{{ item }}</div>
              <!-- <span class="addr">{{ item? item:''}}</span> -->
          </template>
        </el-autocomplete>
      </el-form-item>
      <el-form-item prop="remark" label="备注:">
          <el-input type="textarea" v-model="FormData.remark" maxlength="100" :rows="1" style="width:200px;"></el-input>
        </el-form-item>
    </el-form>
     </div>
     <div class="bottomTable">
      <div class="detailsTitle">
        <h4>货物信息</h4>
      </div>
      <div ref="searchBox2" style="margin-top: 5px;margin-bottom:5px;margin-left:10px;">
        <!-- <span>
          总吨数:
          <span style="color: red">{{Number(totalAllWeight).toFixed(4)}}</span> &nbsp;吨
        </span> -->
        <!-- style="margin-left: 15px" -->
        <span >
          总件数:
          <span style="color: red">{{ totalNumber }}</span> &nbsp;件
        </span>
      </div>
      <el-table
        max-height="300px"
        border
        bordersize="mini"
        size="mini"
        ref="detailsDataList"
        :data="detailsDataList"
        style="width:100%"
        highlight-current-row
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        >
          <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
          <el-table-column prop="number" align="center" label="操作" width="80">
            <template slot-scope="scope1">
              <el-button @click="tabDelClick(scope1.$index,detailsDataList)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="number" align="center" label="件数" width="90">
            <template slot-scope="scope1">
                <el-input
                  v-model.trim="scope1.row.number"
                  @input="changeJianShu(scope1.row,scope1.row.number)"
                  v-number-input.float="0"
                  maxlength="50"
                  placeholder="请输入"
                  size="mini"
                ></el-input>
             </template>
          </el-table-column>
          <el-table-column prop="warehouseId" align="center" label="仓位" width="110">
            <template slot-scope="scope1">
              <el-select filterable clearable v-model="scope1.row.warehouseId" size="mini" placeholder="请选择仓位" @change="selectCangwei(scope1.row)" >
                <el-option v-for="(item,index) in warehouseOptions" :key="index" :label="item.warehouseName" :value="item.warehouseId"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="productTypeName" align="center" label="货物类型" width="100"></el-table-column>
          <el-table-column prop="steelMillName" align="center" label="产地" width="100"></el-table-column>
          <el-table-column prop="specification" align="center" label="规格" width="140"></el-table-column>
          <el-table-column prop="model" align="center" label="材质"  width="110"></el-table-column>
          <el-table-column prop="planNumber" align="center" label="预报件数"></el-table-column>
            <el-table-column prop="planWeight" align="center" label="预报重量(吨)" width="120"></el-table-column>
        </el-table>
     </div>
      <div class="footerBox">
        <el-button type="primary" @click="addPlanClose">取消</el-button>
        <el-button type="primary" @click="finishClick(1)" :loading = 'addLoading'>保存</el-button>
        <el-button type="primary" :loading="confirmLoadingB" @click="finishClick(2)" >保存并过磅</el-button>
      </div>
      <el-drawer
        title="添加货物"
        :modal-append-to-body="false"
        size="100%"
        :visible.sync="addPlanVisible"
        :modal="false"
        :before-close="addPlanClose"
        class="rightDrawer"
      >
      <div style="margin:22px 0 0 10px;">
          <span style="font-size:15px;">规格：</span>
          <el-select v-model="specification" clearable filterable placeholder="请选择" style="width:170px;" size="mini">
            <el-option
              v-for="(item,index) in guigeOptions"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          <el-button type="primary" size="mini" @click="searchClick" style="margin-left:8px;">查询</el-button>
          <el-button type="primary" size="mini" @click="chongZhi" >重置</el-button>
        </div>
        <div style="margin:10px 0 0 10px;">
        <el-table
            size="mini"
            :data="detailsDataCopyAdd"
            ref="detailsDataCopyAdd"
            style="width:100%;"
            :header-cell-style="{background:'#f5f5f5'}"
            @row-click="dianjixuanzhong"
            highlight-current-row
          >
            <el-table-column prop="productTypeName" align="center" label="货物类型"></el-table-column>
            <el-table-column prop="steelMillName" align="center" label="产地"></el-table-column>
            <el-table-column prop="specification" align="center" label="规格"></el-table-column>
            <el-table-column prop="model" align="center" label="材质"></el-table-column>
            <el-table-column prop="warehouseName" align="center" label="仓位"></el-table-column>
            <el-table-column prop="planNumber" align="center" label="预报件数"></el-table-column>
            <el-table-column prop="planWeight" align="center" label="预报重量(吨)"></el-table-column>
          </el-table>
      </div>
      </el-drawer>

    </el-drawer>
  </div>
</template>

<script>
import {
  getRelationCustomer
} from '@/api/wms-stock.js'
import {
  getMasterDetailById, // 修改数据回显
  zidianKuwei,
  getVehicleNoList,
  getSummaryListNoPage,
  getSummaryDropDown,
  createInstockMasterAndSummary // 保存
} from '@/api/wms-access'
import DonMessage from '@/utils/message'
const vhsrule = /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/

export default {
  components: { },
  name: 'XinzengTidan',
  data () {
    return {
      FormData: {
        plateNumber: '',
        primaryCustomerTaxId: '',
        primaryCustomerName: '',
        customerTaxId: '',
        customerName: '',
        arrivalMethod: '船运',
        vehicleNo: '',
        remark: ''
      },
      RKData: [],
      Rules: {
        plateNumber: [
          { required: true, message: '请输入车船号', trigger: 'blur' }
        ],
        vehicleNo: [
          { required: true, message: '请输入车号', trigger: ['blur', 'change'] }
        ],
        primaryCustomerTaxId: [
          { required: true, message: '请选择一级货主', trigger: 'change' }
        ],
        customerTaxId: [
          { required: true, message: '请选择二级货主', trigger: 'change' }
        ],
        arrivalMethod: [
          { required: true, message: '请选择到货方式', trigger: 'blur' }
        ]
      },
      detailsDataList: [],
      arrivalMethodData: [
        {
          value: '1',
          label: '火运'
        },
        {
          value: '2',
          label: '汽运'
        },
        {
          value: '3',
          label: '船运'
        }
      ],
      detailsDataCopyAdd: [],
      xuanzhongArr: null,
      allDataList: [],
      parentData: {},
      addLoading: false,
      confirmLoadingB: false,
      totalAllWeight: 0,
      totalNumber: 0,
      carDerList: [],
      guigeOptions: [],
      specification: '',
      warehouseOptions: []
    }
  },
  props: {
    addPlanVisible: {
      type: Boolean,
      default: true
    },
    planData: {
      type: Object
    },
    shipForecastMasterId: {
      type: Number
    }
  },
  watch: {
    planData: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val) {
          this.parentData = val
        }
      }
    }
  },
  created () {
    this.getRelationCustomerS()
    this.getMasterDetailById()
    this.getSummaryListNoPage()
    this.getSummaryDropDown()
    this.zidianKuweiS()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        // _this.finishClick(2)
      }
    }
  },
  mounted () {
    getVehicleNoList().then(res => {
      this.carDerList = res
    }).catch(error => {
      this.$message({
        showClose: true,
        message: error.message,
        type: 'error',
        onClose () {
        }
      })
    })
  },
  methods: {
    querySearch (str, cb) {
      let arr = []
      this.carDerList.forEach(itme => {
        if (str) {
          if (itme.indexOf(str) != -1) {
            arr.push(itme)
          }
        } else {
          arr.push(itme)
        }
      })
      cb(arr)
    },
    handleSelect (item) {
      this.$set(this.FormData, 'vehicleNo', item)
    },
    searchClick () {
      this.getSummaryListNoPage()
    },
    chongZhi () {
      this.specification = ''
      this.getSummaryListNoPage()
    },
    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({
      })
        .then((res) => {
          this.warehouseOptions = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    selectCangwei (row) {
      if (row.warehouseId != '') {
        row.warehouseName = this.warehouseOptions.filter(item => item.warehouseId == row.warehouseId)[0].warehouseName
      }
      this.$set(row, 'wareHouseId', row.warehouseId)
      this.$set(row, 'wareHouseName', row.warehouseName)
    },
    // 获取货物信息列表
    getSummaryListNoPage () {
      getSummaryListNoPage({
        shipForecastMasterId: this.shipForecastMasterId,
        specification: this.specification
      }).then((res) => {
        this.detailsDataCopyAdd = res
      })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 获取规格下拉框数据
    getSummaryDropDown () {
      getSummaryDropDown(this.shipForecastMasterId)
        .then(res => {
          this.guigeOptions = res.specificationList
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          this.RKData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 获取一二级货主信息
    getMasterDetailById () {
      getMasterDetailById(this.shipForecastMasterId)
        .then(res => {
          this.FormData.plateNumber = res.plateNumber
          this.FormData.primaryCustomerTaxId = res.primaryCustomerTaxId
          this.FormData.customerTaxId = res.customerTaxId
          this.FormData.arrivalMethod = res.arrivalMethod
          this.FormData.plateNumber = res.plateNumber
        }).catch(err => {
          DonMessage.error(err.message)
        })
    },
    // 点击
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      this.$set(row, 'wareHouseId', row.warehouseId)
      this.$set(row, 'wareHouseName', row.warehouseName)
      this.$set(row, 'number', '')
      this.detailsDataList.push(this.xuanzhongArr)
      if (this.detailsDataList.length != 0) {
        let map = new Map()
        for (let i of this.detailsDataList) {
          let str = i.productTypeName + i.steelMillName + i.specification + i.model + i.warehouseName + i.planNumber + i.planWeight
          if (!map.has(str)) {
            map.set(str, i)
          }
        }
        this.detailsDataList = [...map.values()]
        this.totalNumber = this.detailsDataList.reduce((pre, cur) => { return pre / 1 + cur.number / 1 }, 0)
        this.totalAllWeight = this.detailsDataList.reduce((pre, cur) => { return pre / 1 + cur.planWeight / 1 }, 0).toFixed(4)
      }
    },
    tabDelClick (index, rows) {
      rows.splice(index, 1)
      this.totalNumber = this.detailsDataList.reduce((pre, cur) => { return pre / 1 + cur.number / 1 }, 0)
      this.totalAllWeight = this.detailsDataList.reduce((pre, cur) => { return pre / 1 + cur.planWeight / 1 }, 0).toFixed(4)
    },
    // 添加出库计划取消
    addPlanClose () {
      this.$emit('update:addPlanVisible', false)
      this.$parent.xztableData = []
    },
    changeJianShu (row, val) {
      this.totalNumber = this.detailsDataList.reduce((pre, cur) => { return pre / 1 + cur.number / 1 }, 0)
      this.$set(row, 'number', val)
    },
    finishClick (n) {
      this.$refs.FormData.validate(valid => {
        if (valid) {
          if (this.detailsDataList.length == 0) {
            this.$message.error('请选择右侧数据填写货物信息再点击保存')
          } else {
            let chepai = !vhsrule.test(this.FormData.vehicleNo)
            if (chepai) {
              this.$message({ message: '车牌号不正确', type: 'error' })
            } else {
              let flagA = this.detailsDataList.every(item => item.planNumber / 1 != 0)
              if (!flagA) {
                this.$message.error('件数不能为空或0')
                return
              }
              if (flagA) {
                this.addOutStock(n)
              }
            }
          }
        } else {

        }
      })
    },
    // 调接口
    addOutStock (n) {
      if (n == '1') {
        this.addLoading = true
      } else {
        this.confirmLoadingB = true
      }
      let obj = {
        vehicleNo: this.FormData.vehicleNo,
        shipForecastMasterId: this.shipForecastMasterId,
        remark: this.FormData.remark,
        summary: this.detailsDataList
      }
      createInstockMasterAndSummary(obj).then(res => {
        if (n == '1') {
          this.addLoading = false
          this.$message.success('添加成功')
          this.addPlanClose()
          this.$parent.getDataList()
        } else {
          this.confirmLoadingB = false
          this.$message.success('添加成功')
          this.addPlanClose()
          this.$router.push({
            name: 'yycRKPlan',
            // query: {
            //   // 路由传参时push和query搭配使用 ，作用时传递参数
            //   id: 1
            // },
            params: {
              id: 1,
              vehicleNo: this.FormData.vehicleNo
            }
          })
        }
      }).catch(err => {
        if (n == '1') {
          this.addLoading = false
        } else {
          this.confirmLoadingB = false
        }
        this.$message.error(err.message)
      })
    }
  }
}
</script>

<style scoped lang='less'>
.xiala{
  .name{
    color: #000;
    line-height:normal;
    margin-top:6px;
  }
  .addr{
    color: #999;
  }
}
</style>
